import { Injectable } from '@angular/core';

import { Template } from '../../common/models/template';
import { template } from '../../common/helpers/string-helper';

@Injectable()
export class TemplateService {

  template = new Template();

  constructor() { }

  getTemplateByPromoCode(promoCode) {
    if (!promoCode) {
      this.template.name = template.default;
    } else {
      this.template.name = template.promo + promoCode;
    }
    return this.template;
  }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/landing/services/template.service.ts